import React from 'react'
import Button, { ButtonStyle } from '../components/Button'
import VerticalSpacer from '../components/VerticalSpacer'

export interface CtaSpec {
  text: React.ReactNode
  onClick: () => void
  style?: ButtonStyle
  disabled?: boolean
  paddingBefore?: boolean
  id?: string
}

export const ListCtaSection = (props: {
  ctas: readonly CtaSpec[]
}) => {
  return (
    <div className="ctaContainer">
      {
        props.ctas.map(item => (
          <React.Fragment key={item.id}>
            {item.paddingBefore && (
              <VerticalSpacer/>
            )}
            <Button
              disabled={item.disabled}
              buttonStyle={item.style}
              onClick={item.onClick}
            >
              {item.text}
            </Button>
          </React.Fragment>
        ))
      }
    </div>
  )
}